// Colours of the coding kit (Figma component kit, YES-275). Speaker colours follow the wireframes
// (teacher blue, student orange), darkened where needed for AA contrast on white.
export const SPEAKER_COLORS = {
    teacher: '#1565C0',
    student: '#B45309',
    unknown: '#4B5565',
};

export const TARGET = {
    background: '#FFF8C5',
    border: '#D4A72C',
};

// Label-layer chip. Model and LLM are machine layers, dashed purple: researcher screens only.
export const LAYER_STYLES = {
    original: { label: 'Original', color: '#4B5565', background: '#EDF0F2' },
    model: { label: 'Model', color: '#6640A6', background: '#F2EDFC', dashed: true },
    llm: { label: 'LLM', color: '#6640A6', background: '#F2EDFC', dashed: true },
    annotation: { label: 'Annotation', color: '#1157A3', background: '#E8F1FB' },
    adjudication: { label: 'Adjudication', color: '#8A5A00', background: '#FFF6E0' },
    final: { label: 'Final', color: '#1F6B31', background: '#E6F4EA' },
};

export const SPEAKER_LABELS = {
    teacher: 'Teacher',
    student: 'Student',
    unknown: 'Unknown',
};
